<div class="menu">
  @for (item of menu; track item.label) {
    <a class="menu-item" [class.active]="activeItem() === item" [routerLink]="item.link" (click)="activeItem.set(item)">
      <app-svg-icon [name]="item.icon" [title]="item.label" />
    </a>
  }
</div>

@if (activeItem()?.link === '/terminal') {
  <app-keys />
}
